import {IEmployee} from '@signal/asp-data-commons';

const toNumber = n => isNaN(n) ? 0 : +n;

export const employeeIdsToFlatRateHoursProjector = (employees: IEmployee[]) => {
  return employees.map(e => e?.flatRateHours || 0).reduce((sum, num) => toNumber(sum) + toNumber(num), 0);
}

export const employeeAvatarUrlEncoding = (employees: IEmployee[]) => {
  return employees.map(e => ({...e, avatar: encodeURIComponent(e.avatar) }));
}

export const singleEmployeeAvatarUrlEncoding = (employee: IEmployee) => {
  return ({...employee, avatar: encodeURIComponent(employee.avatar) });
}